import {DataLayerModel} from "@merchant-webapp/components";

export enum FilterFieldName {
	STATION_NAME = "by station name",
	ADDRESS = "by address",
	SERVICES = "by services",
	PRODUCTS = "by products",
	SUPPLIERS = "by suppliers",
	UNKNOWN = "unknown"
}

export class FilterStationsDataLayerModel extends DataLayerModel {
	public static readonly EVENT_NAME: string = "FILTER_STATIONS";
	public byField: FilterFieldName;

	public constructor(byField: FilterFieldName) {
		super(FilterStationsDataLayerModel.EVENT_NAME);
		this.byField = byField;
	}

	public static getUsedFilterFields(filters: any): FilterStationsDataLayerModel[] {
		const usedFilterFields: FilterStationsDataLayerModel[] = [];
		Object.keys(filters).forEach((fieldName: string) => {
			const fieldValue = filters[fieldName];
			if (fieldValue instanceof Array) {
				if (this.checkValues(fieldValue)) {
					usedFilterFields.push(new FilterStationsDataLayerModel(this.mapFieldName(fieldName)));
				}
			} else {
				if (this.checkValue(fieldValue)) {
					usedFilterFields.push(new FilterStationsDataLayerModel(this.mapFieldName(fieldName)));
				}
			}
		})
		return usedFilterFields;
	}

	private static checkValue(field: string): boolean {
		return (field !== null || field !== undefined) && field.trim() !== "";
	}

	private static checkValues(field: string[]) {
		return (field !== null || field !== undefined) && field.length > 0;
	}

	private static mapFieldName(fieldName: string): FilterFieldName {
		switch (fieldName) {
			case "address":
				return FilterFieldName.ADDRESS;
			case "products":
				return FilterFieldName.PRODUCTS;
			case "services":
				return FilterFieldName.SERVICES;
			case "station_name":
				return FilterFieldName.STATION_NAME;
			case "supplierIds":
				return FilterFieldName.SUPPLIERS;
			default:
				return FilterFieldName.UNKNOWN;
		}
	}
}